import { getServiceBySlug } from "../data/services";

export const WHATSAPP_NUMBER = "916393387138";

interface WhatsAppContext {
  sourcePath: string;
  sourcePage: string;
  serviceType: string;
  servicePage: string;
  locationName?: string;
}

const serviceTypeBySlug: Record<string, string> = {
  "web-development": "Web & Digital",
  ecommerce: "Web & Digital",
  seo: "Web & Digital",
  "digital-marketing": "Web & Digital",
  "social-media": "Web & Digital",
  branding: "Web & Digital",
  "ui-ux": "Web & Digital",
  "ui-ux-design": "Web & Digital",
  "creative-services": "Web & Digital",
  "seo-services": "Web & Digital",
  wordpress: "Web & Digital",
  shopify: "Web & Digital",
  "content-writing": "Web & Digital",
  "graphic-design": "Web & Digital",

  "crm-development": "Software & Enterprise",
  "erp-development": "Software & Enterprise",
  "web-apps": "Software & Enterprise",
  "mobile-apps": "Software & Enterprise",
  "api-development": "Software & Enterprise",
  "cloud-devops": "Software & Enterprise",
  integrations: "Software & Enterprise",
  "app-development": "Software & Enterprise",
  "custom-software": "Software & Enterprise",

  "ai-agents": "AI & Automation",
  "ai-call-centre": "AI & Automation",
  "llm-integration": "AI & Automation",
  "rag-pipelines": "AI & Automation",
  "rpa-automation": "AI & Automation",
  analytics: "AI & Automation",
  "ai-consulting": "AI & Automation",
};

const sourcePageByPath: Record<string, string> = {
  "/": "Home Page",
  "/about": "About Page",
  "/blog": "Blog Page",
  "/careers": "Careers Page",
  "/contact": "Contact Page",  "/services": "Services Page",
  "/work": "Work Page",
  "/industries": "Industries Page",
  "/products": "Products Page",
  "/india": "India Page",
  "/uae": "UAE Page",
  "/uk": "UK Page",
};

function toTitleCaseFromSlug(input: string) {
  return input
    .split("-")
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}

function getServiceTypeFromPillar(pillar: string) {
  if (pillar === "web-digital") return "Web & Digital";
  if (pillar === "enterprise-systems") return "Software & Enterprise";
  if (pillar === "ai-solutions") return "AI & Automation";
  if (pillar === "custom-software") return "Software & Enterprise";
  if (pillar === "industry-solutions") return "Industry Solutions";
  if (pillar === "strategic-services") return "Strategic Services";
  return "General";
}

export function inferWhatsAppContext(pathname: string): Omit<WhatsAppContext, "locationName"> {
  const normalizedPath = pathname || "/";
  const cleanedPath = normalizedPath.endsWith("/") && normalizedPath !== "/"
    ? normalizedPath.slice(0, -1)
    : normalizedPath;
  const segments = cleanedPath.split("/").filter(Boolean);

  const sourcePage =
    sourcePageByPath[cleanedPath] ||
    (segments[0] === "services"
      ? "Service Page"
      : segments[0] === "industries"
        ? "Industry Page"
        : segments[0] === "products"
          ? "Product Page"
          : segments[0] === "work"
            ? "Case Study Page"
            : "Website Page");

  if (segments[0] === "services" && segments[1]) {
    const serviceSlug = segments[1];
    const catalogService = getServiceBySlug(serviceSlug);
    const servicePage = catalogService?.name ?? toTitleCaseFromSlug(serviceSlug);
    const serviceType = catalogService
      ? getServiceTypeFromPillar(catalogService.pillar)
      : serviceTypeBySlug[serviceSlug] ?? "General Services";

    return {
      sourcePath: cleanedPath,
      sourcePage,
      serviceType,
      servicePage,
    };
  }

  return {
    sourcePath: cleanedPath,
    sourcePage,
    serviceType: "General Inquiry",
    servicePage: "Not on service page",
  };
}

export function getWhatsAppUrl(context: {
  sourcePath: string;
  sourcePage: string;
  serviceType: string;
  servicePage: string;
  locationName?: string;
}) {
  const locationLine = context.locationName ? `Location: ${context.locationName}\n` : "";
  const message = [
    "Hi Obsidian Web Labs!",
    "I would like to discuss a project.",
    "",
    `Source Page: ${context.sourcePage}`,
    `Page URL: ${context.sourcePath}`,
    `Service Type: ${context.serviceType}`,
    `Service Page: ${context.servicePage}`,
    locationLine.trimEnd(),
    "",
    "Please share details and next steps.",
  ]
    .filter(Boolean)
    .join("\n");

  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}